import { IThemeAssetContributor } from '@app/shared/layout/themes/ThemeAssetContributor';
import { ThemeHelper } from '@app/shared/layout/themes/ThemeHelper';
import { Theme1ThemeAssetContributor } from '@app/shared/layout/themes/theme1/Theme1ThemeAssetContributor';

export class ThemeAssetContributorFactory {
    static getCurrent(): IThemeAssetContributor {
        return new Theme1ThemeAssetContributor();
    }
}
